import React from 'react';
import { useNavigate } from 'react-router';
import { PRINCIPAL_INVESTIGATOR, QUALITY_REVIEWER, MARKETING_STAFF, MEDICAL_REVIEWER, MARKETING_HEAD, PMS_ADMIN, base_url } from '../../utilities';
import { useState, useEffect,useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRejectedEventsList, mrSubjectcounts, getMrStudies, getMrDashboardCounts, getMrSubjectList,getPmsStudyData,getPmsdashboardCounts,getPmsDashboardChartData,getPmsInfo,getPmsSubjectList,getPmsSubjectdashboardCounts, getPmsSubjectDtls,getStudyForDose,getAllSubjectsToAddAE, getPiRejSubject,getNewPmsStudyData,getConcludedData} from '../../Redux/actions/actions';
import { getPiStudies, getMSSitesDropdowns,getPmsReportsChartData, getMSSubjectList, getMSSubjectCounts, getSubjectList, getMSDropdowns, getSubjectCounts, getStudyInfo, getPiDashboardChartData, getQrStudies, getQrInfo, getqrdashboardCounts2, getmsdashboardcounts, getqrdashboardCounts, getQrSubjectList, getQrDashboardStudies, getMrInfo, getQrSubjectReviewList, getSubjectsRelatedCounts,getPmsChangerLoggerData } from '../../Redux/actions/actions';
import {getPmsNotifications} from '../../Redux/actions/actions'
import {getMHStudies, getMHDBCounts, getMHSubjectList, getmhsubjectlistcounts} from "../../Redux/actions/actions"
import axios from '../../axios-interceptor';
import Swal from 'sweetalert2';
import NotificationComponent from "./NotificationComponent"
import { FaEye, FaEyeSlash ,FaTimes} from "react-icons/fa";
import Select from "react-select";
import version from '../../version';
import packageJson from '../../../package.json';

const NavigationBar = ({clearField, studyDropdwn, getStudieId, title, btnDisable, selectedStudy, handleFilteredData, handleFilter, filterCondition,setClearFilters }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getPiStudiesList = useSelector((state) => state.piStudyList);
  const getQrData = useSelector((state) => state.qrStudyList);
  const getMrData = useSelector((state) => state.mrStudyList);
  const getPmsStudyData1 = useSelector((state) => state.getNewPmsStudiesData);

  const msdropdowns = useSelector((state) => state.msdropdowns);
  

  const pmsNotifications = useSelector((state) => state.pmsNotifications)
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('Note: Password must be at least 8 characters long, contain uppercase and lowercase letters, and include special characters.');
  const [isPasswordMatching, setIsPasswordMatching] = useState(false);
  const [showCard, setShowCard] = useState(true);
  const currentPath = window.location.pathname;
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [isActive, setIsActive] = useState(true); // Assume the application is initially active
  const [notifications, setNotifications] = useState([]);
  const mhMainStudies = useSelector((state) => state.mhMainStudies);
  const updateActivityStatus = () => {
    setIsActive(true);
  };
  let rolecode = (localStorage.getItem("role_code"))
  const handleCloseFirstModal = () => {
    
    const firstModal = document.getElementById('upadtemodel');
    if (firstModal) {
      firstModal.classList.remove('show');
    }
    setShowCard(false); // Hide the card content
    setShowModal(true); // Show the second modal
  };
  const getBackgroundColor = () => {
  if (rolecode == PMS_ADMIN) {
      return '#00A69F';
    } else if (rolecode == PRINCIPAL_INVESTIGATOR) {
      return '#285B76';
    } else if (rolecode == MEDICAL_REVIEWER) {
      return '#BDCDD6';
    } else if (rolecode == QUALITY_REVIEWER) {
      return '#DF9149';
    } else if (rolecode == MARKETING_HEAD) {
      return '#D0B8A8';
    } else {
      return '#B1D57C';
    }
  };

  // this is the code for session logout
  const closeLiveNotification = (newNotification) => {
    setNotifications((prevNotifications) =>
      prevNotifications.filter((notification) => notification !== newNotification)
    );
  };

  const [expirationTime, setExpirationTime] = useState(29 * 60 ); // 30 minutes in seconds
// Function to update the token
const updateToken = () => {
  axios
    .post(base_url + 'sessions/update_access_token', {
      email: localStorage.getItem('email'),
      refresh_token: localStorage.getItem('refresh_token'),
      device_identifier: localStorage.getItem('device_identifier'),
    })
    .then((res) => {
      setExpirationTime(28 * 60);
      setLastInteractionTime(new Date().getTime())
      localStorage.setItem('access_token', res.data?.updatedAccessToken);
      setExpirationTime(29*60)
    })
    .catch((err) => {
      console.error('Error updating token:', err);
      // You may want to implement a retry mechanism here
    });
};


const [lastInteractionTime, setLastInteractionTime] = useState(new Date().getTime());
const [userActivity, setUserActivity] = useState(1); // 1 for active, 0 for inactive
const [firstInactivity, setFirstInactivity] = useState(true);


useEffect(()=>{
  if (firstInactivity && userActivity===0) {
    setExpirationTime(29 * 60);
    setFirstInactivity(false);
  }
},[userActivity])

useEffect(() => {
  // Handle focus and blur events to track application state
  const handleBlur = () => {
    setUserActivity(0);
    setLastInteractionTime(new Date().getTime());
    setFirstInactivity(true);
  };

  const handleFocus = () => {
    setUserActivity(1);
    setLastInteractionTime(new Date().getTime());
  };

  const handleMouse=()=>{
    setUserActivity(1);
    setLastInteractionTime(new Date().getTime());
  }


  window.addEventListener('blur', handleBlur);
  window.addEventListener('focus', handleFocus);
  window.addEventListener('mousemove', handleMouse);

  return () => {
    window.removeEventListener('blur', handleBlur);
    window.removeEventListener('focus', handleFocus);
    window.removeEventListener('mousemove', handleMouse);
    
  };
}, []);

useEffect(() => {
  const handleVisibilityChange = () => {
    if (document.hidden) {
      setUserActivity(0); // User's operating system is locked
    } else {
      setUserActivity(1); // User's operating system is unlocked
      setLastInteractionTime(new Date().getTime());
    }
  };
  window.addEventListener('visibilitychange', handleVisibilityChange);
  return () => {
    window.removeEventListener('visibilitychange', handleVisibilityChange);
  };
}, []);

useEffect(() => {
  const activityTimer = setInterval(() => {
    const currentTime = new Date().getTime();
    const lastLoginTime = localStorage?.getItem('lastLoginTime');
    const timeElaps = (currentTime - Number(lastLoginTime)) / 1000; // Convert to seconds
    const timeElapsed = (currentTime - lastInteractionTime) / 1000; // Convert to seconds
    if (timeElaps > 600 && userActivity!==0) {
      updateToken(); // Update the token
      localStorage.setItem('lastLoginTime', currentTime); // Update last login time
    }
    else if (userActivity === 1 && timeElapsed > (expirationTime - 60)) {
      updateToken();// Update the token
      localStorage.setItem('lastLoginTime', currentTime); // Update last login time
    }
    else if (userActivity === 0 && timeElapsed > expirationTime) {
      window.isExpired=true;
      localStorage.clear();
    }
  }, 1000); // Check every 1 second
  return () => {
    clearInterval(activityTimer);
  };
}, [userActivity, expirationTime, lastInteractionTime]);


const handleUserInteraction = () => {
    setLastInteractionTime(Date.now()); 
};

const mouseMoveHandler = (e) => {
  handleUserInteraction();
};

const removeMouseMoveHandler = (e) => {
  handleUserInteraction();
};

  useEffect(() => {
if(!localStorage.refresh_token){
  window.isExpired =true
}
  if (window.isExpired) {
    Swal.fire({
      title: 'Session Expired',
      text: 'Your session has expired. Please log in again.',
      icon: 'warning',
      confirmButtonText: 'OK',
      allowOutsideClick: false, // This prevents closing by clicking outside the modal

    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(base_url + 'sessions/logout', {
            email: localStorage.getItem('email'),
            refresh_token: localStorage.getItem('refresh_token'),
          })
          .then((res) => {
            localStorage.clear();
            navigate('/');
            window.location.reload();
          })
          .catch((err) => {
            console.log(err);
            localStorage.clear();
            navigate('/');
            window.location.reload();
          });
      }
    });
  }
}, [window.isExpired, localStorage.refresh_token]);




  useEffect(() => {

    if (rolecode == PRINCIPAL_INVESTIGATOR) {
      dispatch(getPiStudies(localStorage.login_user_id))
    }
    dispatch(getStudyInfo(null))

    if (rolecode == QUALITY_REVIEWER) {
      dispatch(getQrStudies())
    }

    if(rolecode == MEDICAL_REVIEWER){
      dispatch(getMrStudies())
    }
   
  }, [dispatch, btnDisable, rolecode])

  useEffect(() => {
    if (rolecode == PMS_ADMIN) {
      dispatch(getPmsNotifications({
        user_id: localStorage.login_user_id,
        user_persona: PMS_ADMIN,
        
      }))
    }
  }, [dispatch, rolecode])

  useEffect(() => {
    if (rolecode == PRINCIPAL_INVESTIGATOR) {
      dispatch(getPmsNotifications({
            user_id: localStorage.login_user_id,
            pi_id:localStorage.pi_id,
            user_persona: PRINCIPAL_INVESTIGATOR
      }))
    }
  }, [dispatch, rolecode])

  useEffect(() => {
    const value = msdropdowns?.map(item => item.study_id)
    if (rolecode == MARKETING_STAFF && value) {
      dispatch(getPmsNotifications({
        user_id: localStorage.login_user_id,
        user_persona: MARKETING_STAFF,
        study_id: value
      }))
    }
  }, [dispatch, msdropdowns, rolecode])

  useEffect(() => {
    let value = getQrData?.map(item => item.study_id)
    value = value === undefined ? [] : value
    if (rolecode == QUALITY_REVIEWER && value) {
      dispatch(getPmsNotifications({
        user_id: localStorage.login_user_id,
        user_persona: QUALITY_REVIEWER,
        study_id: value
      }))
    }
  }, [dispatch, getQrData, rolecode])

  useEffect(() => {
    const value = mhMainStudies?.map(item => item.study_id)
    if (rolecode == MARKETING_HEAD && value) {
      dispatch(getPmsNotifications({
        user_id: localStorage.login_user_id,
        user_persona: MARKETING_HEAD,
        study_id: value,
        zone_id: localStorage.getItem("mh_zone_id")
      }))
    }
  }, [dispatch, mhMainStudies, rolecode])

  useEffect(() => {
    let value = getMrData?.map(item => item.study_id)
    value = value === undefined ? [] : value
    if (rolecode == MEDICAL_REVIEWER && value) {
      dispatch(getPmsNotifications({
        user_id: localStorage.login_user_id,
        user_persona: MEDICAL_REVIEWER,
        study_id: value
      }))
    }
  }, [dispatch, getMrData, rolecode])

  
  async function logOut() {
    axios.post(base_url + "sessions/logout", {
      "email":localStorage.getItem('email'),
      "refresh_token": localStorage.getItem('refresh_token'),
      "device_identifier":localStorage.getItem('device_identifier')
    })
      .then(res => {
        localStorage.clear();
        navigate("/");
        window.location.reload()
      })
      .catch(err => {
        console.log(err);
        localStorage.clear();
        navigate("/");
        window.location.reload()
      })

  }
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    validatePassword(e.target.value, confirmPassword);
  };
  const defaultValue = getPiStudiesList && getPiStudiesList[0]?.study_id;
  const defaultQrValue = getQrData && getQrData[0]?.study_id;
  const defaultPmsValue = getPmsStudyData1 && getPmsStudyData1[0]?.study_id;
  const defaultMrValue = getMrData && getMrData[0]?.study_id;

  const [studyOption, setStudyOption] = useState([defaultValue, ''])
  const [newIdQrValue] = useState(localStorage.study_id)
  const [newIdPmsValue] = useState(localStorage.study_id)

  const [newIdMrValue] = useState(localStorage.study_id)
  const mssitesdropdown = useSelector((state) => state.mssitesdropdown);
  

// main useEffect for PMS
  useEffect(() => {
    if (rolecode == PMS_ADMIN) {
      if (getPmsStudyData1?.length > 0) {
        
        if (!localStorage.getItem("study_id")) {
          
          localStorage.setItem("study_id", getPmsStudyData1 && getPmsStudyData1[0]?.study_id);
          localStorage.setItem("study_name",getPmsStudyData1 && getPmsStudyData1[0]?.study_name);
        }
        else{
          getPmsStudyData1?.map((ele)=>{
              if(ele?.study_id == localStorage.getItem("study_id")){
                
                // handlePmsChange(ele?.study_id)
                  localStorage.setItem("study_id", ele?.study_id);
              }
          })
        }
        
    
    dispatch(getPmsdashboardCounts(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))
    dispatch(getPmsDashboardChartData(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))
    dispatch(getConcludedData(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))
    dispatch(getPmsSubjectList(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))
    dispatch(getPmsSubjectdashboardCounts(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))

    dispatch(getSubjectsRelatedCounts(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))
    dispatch(getQrSubjectReviewList({ study_id: localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id }))
    // dispatch(getPmsSubjectDtls({study_id:localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id,dose:1}))
    dispatch(getPmsReportsChartData(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))
    dispatch(getPmsChangerLoggerData())
    dispatch(getQrSubjectList({ study_id: localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id }))
    if (!localStorage.study_id) {
      dispatch(getPmsInfo(getPmsStudyData1 && getPmsStudyData1[0]))
    }
    else {
      const eleWithStudyNameLocalstrg = getPmsStudyData1?.find((study) => study.study_id === localStorage.study_id)

      dispatch(getPmsInfo(eleWithStudyNameLocalstrg))
    }

    dispatch(getQrDashboardStudies({
      "study_id": localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id
    }
    ))
  

    if (defaultPmsValue && newIdPmsValue === undefined) {
      //  ==for qr=====
      dispatch(getSubjectsRelatedCounts(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))
      dispatch(getQrSubjectReviewList({ study_id: 
        
        localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id
        
      }))
      //  ==for qr=====
      
      
      dispatch(getPmsdashboardCounts(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))
      dispatch(getPmsDashboardChartData(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))
      dispatch(getConcludedData(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))
      dispatch(getPmsSubjectList(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))
      dispatch(getPmsSubjectdashboardCounts(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))
      // dispatch(getPmsSubjectDtls(localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id))


      dispatch(getQrSubjectList({ study_id: localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id }))
      if (!localStorage.study_id) {
        dispatch(getPmsInfo(getPmsStudyData1 && getPmsStudyData1[0]))
      }
      else {
        const eleWithStudyNameLocalstrg = getPmsStudyData1.find((study) => study.study_id === localStorage.study_id)

        dispatch(getPmsInfo(eleWithStudyNameLocalstrg))
      }

      dispatch(getQrDashboardStudies({
        "study_id": localStorage.study_id === undefined ? defaultPmsValue : localStorage.study_id
      }
      ))
    }
      }
    }
    
  },[defaultPmsValue, dispatch, defaultPmsValue, localStorage.study_id, getQrData, studyDropdwn])


// main useEffect for MR
  useEffect(() => {
    if (rolecode == MEDICAL_REVIEWER) {
      if (getMrData?.length > 0) {
        if (!localStorage.getItem("study_id")) {
          localStorage.setItem("study_id", getMrData && getMrData[0]?.study_id);
        }
        else{
          getMrData?.map((ele)=>{
              if(ele?.study_id == localStorage.getItem("study_id")){
                
                // handlePmsChange(ele?.study_id)
                  localStorage.setItem("study_id", ele?.study_id);
              }
          })
        }

        dispatch(getMrDashboardCounts(localStorage.study_id === undefined ? defaultMrValue : localStorage.study_id))
      dispatch(getMrSubjectList({ study_id: localStorage.study_id === undefined ? defaultMrValue : localStorage.study_id }))
      if (!localStorage.study_id) {
        dispatch(getMrInfo(getMrData && getMrData[0]))
        dispatch(mrSubjectcounts(getMrData && getMrData[0]?.study_id))
      }
      else {
        const eleWithStudyNameLocalstrg = getMrData.find((study) => study.study_id === localStorage.study_id)

        dispatch(getMrInfo(eleWithStudyNameLocalstrg))
        dispatch(mrSubjectcounts(localStorage.study_id))
      }
        
      }
    }
  },[defaultMrValue,dispatch, defaultMrValue, localStorage.study_id, getMrData])

// main useEffect for QR
  useEffect(()=>{
    if (rolecode == QUALITY_REVIEWER) {
      if (getQrData?.length > 0) {
        if (!localStorage.getItem("study_id")) {
          
          localStorage.setItem("study_id", getQrData && getQrData[0]?.study_id);
        }
        else{
          getQrData?.map((ele)=>{
              if(ele?.study_id == localStorage.getItem("study_id")){
                
                // handlePmsChange(ele?.study_id)
                  localStorage.setItem("study_id", ele?.study_id);
              }
          })
        }

        dispatch(getqrdashboardCounts(localStorage.study_id === undefined ? defaultQrValue : localStorage.study_id))
      dispatch(getSubjectsRelatedCounts(localStorage.study_id === undefined ? defaultQrValue : localStorage.study_id))
      dispatch(getQrSubjectList({ study_id: localStorage.study_id === undefined ? defaultQrValue : localStorage.study_id }))
      dispatch(getQrSubjectReviewList({ study_id: localStorage.study_id === undefined ? defaultQrValue : localStorage.study_id }))
      if (!localStorage.study_id) {
        dispatch(getQrInfo(getQrData && getQrData[0]))
      }
      else {
        const eleWithStudyNameLocalstrg = getQrData.find((study) => study.study_id === localStorage.study_id)

        dispatch(getQrInfo(eleWithStudyNameLocalstrg))
      }

      dispatch(getQrDashboardStudies({
        "study_id": localStorage.study_id === undefined ? defaultQrValue : localStorage.study_id
      }
      ))

      }
    }
  },[defaultQrValue,dispatch, defaultQrValue, localStorage.study_id, getQrData])


// main useEffect for PI

  useEffect(()=>{
    if(rolecode==PRINCIPAL_INVESTIGATOR){
      if (getPiStudiesList?.length > 0) {
        if (!localStorage.getItem("study_id")) {
          localStorage.setItem("study_id", getPiStudiesList && getPiStudiesList[0]?.study_id);
        }
        else{
          getPiStudiesList?.map((ele)=>{
              if(ele?.study_id == localStorage.getItem("study_id")){
                
                // handlePmsChange(ele?.study_id)
                  localStorage.setItem("study_id", ele?.study_id);
              }
          })
        }

        setStudyOption([localStorage.study_id === undefined ? defaultValue : localStorage.study_id, ''])

      dispatch(getPiDashboardChartData({
        "pi_id": localStorage.getItem('pi_id'),
        "study_id": localStorage.study_id === undefined ? defaultValue : localStorage.study_id
      }
      ))

      dispatch(getSubjectList(
        {
          pi_id: localStorage.getItem('pi_id'),
          study_id: localStorage.study_id === undefined ? defaultValue : localStorage.study_id
        }
      ));
      dispatch(getSubjectCounts(
        {
          pi_id: localStorage.getItem('pi_id'),
          study_id: localStorage.study_id === undefined ? defaultValue : localStorage.study_id
        }
      ));
      dispatch(getRejectedEventsList({
        pi_id: localStorage.getItem("pi_id"),
        study_id: localStorage.study_id === undefined ? defaultValue : localStorage.study_id
      }))
      dispatch(getStudyForDose({
        pi_id: localStorage.getItem('pi_id'),
        study_id: localStorage.study_id === undefined ? defaultValue : localStorage.study_id
      }))
      dispatch(getAllSubjectsToAddAE({
        pi_id: localStorage.getItem('pi_id'),
        study_id: localStorage.study_id === undefined ? defaultValue : localStorage.study_id
      }))
      dispatch(getPiRejSubject({
        pi_id: localStorage.getItem('pi_id'),
        study_id: localStorage.study_id === undefined ? defaultValue : localStorage.study_id
      }))
      if (!localStorage.study_id) {
        dispatch(getStudyInfo(getPiStudiesList && getPiStudiesList[0]))
      }

      else {
        const eleWithStudyNameLocalstrg = getPiStudiesList.find((study) => study.study_id === localStorage.study_id)

        dispatch(getStudyInfo(eleWithStudyNameLocalstrg))
      }

      }
    }
  },[defaultValue])


  
  // useEffect(() => {

  //   if (defaultValue && newIdValue === undefined) {
  //     setStudyOption([localStorage.study_id === undefined ? defaultValue : localStorage.study_id, ''])

  //     dispatch(getPiDashboardChartData({
  //       "pi_id": localStorage.getItem('pi_id'),
  //       "study_id": localStorage.study_id === undefined ? defaultValue : localStorage.study_id
  //     }
  //     ))

  //     dispatch(getSubjectList(
  //       {
  //         pi_id: localStorage.getItem('pi_id'),
  //         study_id: localStorage.study_id === undefined ? defaultValue : localStorage.study_id
  //       }
  //     ));
  //     dispatch(getSubjectCounts(
  //       {
  //         pi_id: localStorage.getItem('pi_id'),
  //         study_id: localStorage.study_id === undefined ? defaultValue : localStorage.study_id
  //       }
  //     ));
  //     dispatch(getRejectedEventsList({
  //       pi_id: localStorage.getItem("pi_id"),
  //       study_id: localStorage.study_id === undefined ? defaultValue : localStorage.study_id
  //     }))
  //     dispatch(getStudyForDose({
  //       pi_id: localStorage.getItem('pi_id'),
  //       study_id: localStorage.study_id === undefined ? defaultValue : localStorage.study_id
  //     }))
  //     dispatch(getAllSubjectsToAddAE({
  //       pi_id: localStorage.getItem('pi_id'),
  //       study_id: localStorage.study_id === undefined ? defaultValue : localStorage.study_id
  //     }))
  //     dispatch(getPiRejSubject({
  //       pi_id: localStorage.getItem('pi_id'),
  //       study_id: localStorage.study_id === undefined ? defaultValue : localStorage.study_id
  //     }))
  //     if (!localStorage.study_id) {
  //       dispatch(getStudyInfo(getPiStudiesList && getPiStudiesList[0]))
  //     }

  //     else {
  //       const eleWithStudyNameLocalstrg = getPiStudiesList.find((study) => study.study_id === localStorage.study_id)

  //       dispatch(getStudyInfo(eleWithStudyNameLocalstrg))
  //     }


  //   }
  // }, [defaultValue])



  // function clearLocalStorageItem(key) {
  //   localStorage.removeItem("study_id");
  // }

  // window.addEventListener('beforeunload', function () {
  //   clearLocalStorageItem('selectedOption');
  // });



  //useEffect for Qr
  // useEffect(() => {

  //   if (defaultQrValue && newIdQrValue === undefined) {
       

  //     dispatch(getqrdashboardCounts(localStorage.study_id === undefined ? defaultQrValue : localStorage.study_id))
  //     dispatch(getSubjectsRelatedCounts(localStorage.study_id === undefined ? defaultQrValue : localStorage.study_id))
  //     dispatch(getQrSubjectList({ study_id: localStorage.study_id === undefined ? defaultQrValue : localStorage.study_id }))
  //     dispatch(getQrSubjectReviewList({ study_id: localStorage.study_id === undefined ? defaultQrValue : localStorage.study_id }))
  //     if (!localStorage.study_id) {
  //       dispatch(getQrInfo(getQrData && getQrData[0]))
  //     }
  //     else {
  //       const eleWithStudyNameLocalstrg = getQrData.find((study) => study.study_id === localStorage.study_id)

  //       dispatch(getQrInfo(eleWithStudyNameLocalstrg))
  //     }

  //     dispatch(getQrDashboardStudies({
  //       "study_id": localStorage.study_id === undefined ? defaultQrValue : localStorage.study_id
  //     }
  //     ))
  //   }
  // }, [dispatch, defaultQrValue, localStorage.study_id, getQrData])
  
  
  // use effect for MR-New

  // useEffect(() => {

  //   if (defaultMrValue && newIdMrValue === undefined) {
     

  //     dispatch(getMrDashboardCounts(localStorage.study_id === undefined ? defaultMrValue : localStorage.study_id))
  //     dispatch(getMrSubjectList({ study_id: localStorage.study_id === undefined ? defaultMrValue : localStorage.study_id }))
  //     if (!localStorage.study_id) {
  //       dispatch(getMrInfo(getMrData && getMrData[0]))
  //       dispatch(mrSubjectcounts(getMrData && getMrData[0]?.study_id))
  //     }
  //     else {
  //       const eleWithStudyNameLocalstrg = getMrData.find((study) => study.study_id === localStorage.study_id)

  //       dispatch(getMrInfo(eleWithStudyNameLocalstrg))
  //       dispatch(mrSubjectcounts(localStorage.study_id))
  //     }

      
  //   }
  // }, [dispatch, defaultMrValue, localStorage.study_id, getMrData])

  // use effect for MS

  useEffect(() => {
    if (rolecode == MARKETING_STAFF) {
      if (!msdropdowns) {
        dispatch(getMSDropdowns({
          "user_id": localStorage.getItem("ms_id")
        }))
      }
    }
  }, [dispatch, getMSDropdowns])

   
  
  useEffect(() => {
    if (rolecode == MARKETING_STAFF) {
      if (msdropdowns?.length > 0) {
        if (!localStorage.getItem("studyID")) {
          localStorage.setItem("studyID", msdropdowns && msdropdowns[0]?.study_id);
        }

        const study = msdropdowns?.find(study => study?.study_id === localStorage.studyID);
        dispatch(getMSSitesDropdowns(study))
        dispatch(getMSSubjectCounts({
          study_id: localStorage.getItem("studyID"),
          site_id: mssitesdropdown && mssitesdropdown[0]?.value
        }))
        if(mssitesdropdown !=null){
          if(mssitesdropdown[0]?.value !=null){
        dispatch(getmsdashboardcounts(
          {
            studyID: localStorage.getItem("studyID"),
            siteID: mssitesdropdown && mssitesdropdown[0]?.value
          }

        ))
      }
    }
  }}
  }, [dispatch, msdropdowns,mssitesdropdown && mssitesdropdown[0]?.value])



  useEffect(() => {
    if (rolecode == MARKETING_HEAD) {
      if (!mhMainStudies) {
        dispatch(getMHStudies({
          "user_id": localStorage.getItem("user_id")
        }))
      }
    }
  }, [dispatch, getMHStudies])

 
  useEffect(() => {
    if (rolecode == MARKETING_HEAD) {
      if(mhMainStudies?.length > 0){
        if (!localStorage.getItem("study_id")) {
          localStorage.setItem("study_id", mhMainStudies[0]?.study_id)
          localStorage.setItem("study_name", mhMainStudies[0]?.study_name)
          localStorage.setItem("estimated_subjects", mhMainStudies[0]?.estimated_subjects)
          localStorage.setItem("estimated_sites", mhMainStudies[0]?.estimated_sites)
          localStorage.setItem("number_of_doses", mhMainStudies[0]?.number_of_doses)
          localStorage.setItem("study_initiation_date", mhMainStudies[0]?.study_initiation_date)


          dispatch(getMHDBCounts({
            study_id: mhMainStudies[0]?.study_id,
            mh_id: localStorage.getItem("mh_id"),
            zone_id: localStorage.getItem("mh_zone_id"),
          }))

          dispatch(getMHSubjectList(
            {
                study_id: mhMainStudies[0]?.study_id
            }
        ));
        dispatch(getmhsubjectlistcounts(
          {
              study_id: mhMainStudies[0]?.study_id
          }
      ));
        }
        else{
          dispatch(getMHDBCounts({
            study_id: localStorage.getItem("study_id"),
            mh_id: localStorage.getItem("mh_id"),
            zone_id: localStorage.getItem("mh_zone_id"),
          }))

          dispatch(getMHSubjectList(
            {
                study_id: localStorage.getItem("study_id")
            }
        ));
        dispatch(getmhsubjectlistcounts(
          {
              study_id: localStorage.getItem("study_id")
          }
      ));
        }
      }
      
    }
  }, [dispatch, mhMainStudies, rolecode])

  const handleMHChange = (selectedOption) => {
    if (filterCondition == 0) {
      handleFilter();
    }
    const newQrValue = selectedOption.value;
    localStorage.setItem("study_id", newQrValue)
    
    dispatch(getMHDBCounts({
      study_id: newQrValue,
      mh_id: localStorage.getItem("mh_id"),
      zone_id: localStorage.getItem("mh_zone_id"),
    }))

    dispatch(getMHSubjectList(
      {
          study_id: newQrValue
      }
  ));
  
  dispatch(getmhsubjectlistcounts(
    {
        study_id: newQrValue
    }
));
  }

  const handleMSChange = (selectedOption) => {
    if (filterCondition == 0) {
      handleFilter();
    }
    const newQrValue = selectedOption.value;
    const study = msdropdowns?.find(study => study?.study_id === newQrValue);

    dispatch(getMSSitesDropdowns(study))


    localStorage.setItem("studyID", newQrValue)
    dispatch(getMSSubjectCounts({
      study_id: newQrValue,
      site_id: study.sites[0].site_id
    }))
    dispatch(getmsdashboardcounts(
      {
        studyID: newQrValue,
        siteID: study.sites[0].site_id
      }
    ))
    // if(location.pathname === "/marketingstaffsubjectlist"){
    dispatch(getMSSubjectList(
      {
        study_id: localStorage.getItem("studyID"),
        site_id: study.sites[0].site_id
      }
    ));
    // }

  };

  if (window.location.pathname === '/subjectregistration') {
    selectedStudy(studyOption)

  }


  const [notificationCount, setNotificationCount] = useState(6);

  let user_name = (localStorage?.login_user_name)
  const userName = user_name?.charAt(0).toUpperCase() + user_name?.slice(1);

  const [newIdValue, setNewIdValue] = useState()

  const handleChange = (selectedOption, option) => {
    if(window.location.pathname==='/addnewdosetosubject'){clearField()}
    const newValue = selectedOption.value;
    localStorage.setItem("study_id", newValue)
    setNewIdValue(newValue)
    setStudyOption([localStorage.study_id, option])
    if (window.location.pathname === '/pisubjectslist') { handleFilteredData() }
    dispatch(getSubjectList(
      {
        pi_id: localStorage.getItem('pi_id'),
        study_id: localStorage.study_id
      }
    ));
    dispatch(getRejectedEventsList({
      pi_id: localStorage.getItem("pi_id"),
      study_id: localStorage.study_id
    }))
    dispatch(getSubjectCounts(
      {
        pi_id: localStorage.getItem('pi_id'),
        study_id: localStorage.study_id
      }
    ));
    dispatch(getPiDashboardChartData({
      "pi_id": localStorage.getItem('pi_id'),
      "study_id": localStorage.study_id
    }
    ))
    dispatch(getStudyForDose({
      "pi_id": localStorage.getItem('pi_id'),
      "study_id": localStorage.study_id
    }))
    dispatch(getAllSubjectsToAddAE({
      "pi_id": localStorage.getItem('pi_id'),
      "study_id": localStorage.study_id
    }))
    dispatch(getPiRejSubject({
      "pi_id": localStorage.getItem('pi_id'),
      "study_id": localStorage.study_id
    }))

    const elementWithStudyName = getPiStudiesList.find((study) => study.study_id === newValue);
    const eleWithStudyNameLocalstrg = getPiStudiesList.find((study) => study.study_id === localStorage.study_id)
    if (localStorage.study_id === undefined) {
      dispatch(getStudyInfo(elementWithStudyName))
    }
    else {
      dispatch(getStudyInfo(eleWithStudyNameLocalstrg))
    }
  };

  

  const handlePmsChange = (selectedOption) => {
    // const newPmsValue = e.target.value;
    // localStorage.setItem("study_id", newPmsValue)
    const newPmsValue = selectedOption.value;
    localStorage.setItem("study_id", newPmsValue);
    localStorage.setItem("study_name",selectedOption.label);
    if(setClearFilters!==undefined){
    setClearFilters(true);
    }
    dispatch(getSubjectsRelatedCounts(localStorage.study_id))
    dispatch(getQrSubjectReviewList({ study_id: localStorage.study_id }))
    dispatch(getPmsdashboardCounts(localStorage.study_id))
    dispatch(getPmsDashboardChartData(localStorage.study_id ))
    dispatch(getConcludedData(localStorage.study_id ))
    dispatch(getPmsSubjectList(localStorage.study_id ))
    dispatch(getPmsSubjectdashboardCounts(localStorage.study_id))
    // dispatch(getPmsSubjectDtls(localStorage.study_id))
    dispatch(getPmsReportsChartData(localStorage.study_id))
    dispatch(getPmsChangerLoggerData())


    const elementWithStudyName = getPmsStudyData1?.find((study) => study.study_id === newPmsValue)
    const eleWithStudyNameLocalstrg = getPmsStudyData1?.find((study) => study.study_id === localStorage.study_id)
    if (localStorage.study_id === undefined) {
      dispatch(getPmsInfo(elementWithStudyName))
    }
    else {
      dispatch(getPmsInfo(eleWithStudyNameLocalstrg))
    }
  };



  const handleQrChange = (selectedOption) => {
    const newQrValue = selectedOption.value;
    localStorage.setItem("study_id", newQrValue)
 

    dispatch(getqrdashboardCounts(localStorage.study_id))
    dispatch(getSubjectsRelatedCounts(localStorage.study_id))
    dispatch(getQrSubjectList({ study_id: localStorage.study_id }))
    dispatch(getQrSubjectReviewList({ study_id: localStorage.study_id }))
    dispatch(getQrDashboardStudies({ study_id: localStorage.study_id }))


    const elementWithStudyName = getQrData?.find((study) => study.study_id === newQrValue)
    const eleWithStudyNameLocalstrg = getQrData?.find((study) => study.study_id === localStorage.study_id)
    if (localStorage.study_id === undefined) {
      dispatch(getQrInfo(elementWithStudyName))
    }
    else {
      dispatch(getQrInfo(eleWithStudyNameLocalstrg))
    }
  };
  const [showNotifications, setShowNotifications] = useState(false);
     const notificationBarRef = useRef(null);
     const toggleNotifications = (event) => {
      if(event && !showNotifications){
        event.stopPropagation();
      }
      
     setShowNotifications(!showNotifications);
 };

const handleEscKeyPress = (event) => {
  if (event.keyCode === 27) {
    setShowNotifications(false);
  }
};

useEffect(() => {
  document.addEventListener('keydown', handleEscKeyPress);

  return () => {
    document.removeEventListener('keydown', handleEscKeyPress);
  };
}, []); // Add and remove the event listener when the component mounts/unmounts

// const handleClickOutside = (event) => {
//   if (showNotifications && notificationBarRef.current && !notificationBarRef.current.contains(event.target)) {
//     setShowNotifications(false);
//   }
// };
const notificationComponentRef = useRef(null);
const handleClickOutside = (event) => {
  if (
    showNotifications &&
    notificationBarRef.current &&
    notificationComponentRef.current &&
    !notificationBarRef.current.contains(event.target) &&
    !notificationComponentRef.current.contains(event.target)
  ) {
    setShowNotifications(false);
  }
};

useEffect(() => {
  document.addEventListener('mousedown', handleClickOutside);

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [showNotifications]);

  const [newStudy, setNewStudy] = useState()

  const handleMrChange = (selectedOption) => {

    const newMrValue = selectedOption.value;
    localStorage.setItem("study_id", newMrValue)
 

    dispatch(getMrDashboardCounts(localStorage.study_id))
    dispatch(getMrSubjectList({ study_id: localStorage.study_id }))
    // dispatch(getQrDashboardStudies({ study_id: localStorage.study_id }))
    dispatch(mrSubjectcounts(localStorage.study_id))


    const elementWithStudyName = getMrData?.find((study) => study.study_id === newMrValue)
    const eleWithStudyNameLocalstrg = getMrData?.find((study) => study.study_id === localStorage.study_id)
    if (localStorage.study_id === undefined) {
      dispatch(getMrInfo(elementWithStudyName))
    }
    else {
      dispatch(getMrInfo(eleWithStudyNameLocalstrg))
    }

  };
  
  const options = getPiStudiesList && getPiStudiesList?.map(i => ({
    label: i.study_name,
    value: i.study_id
  }))
  const qrOptions = getQrData && getQrData?.map(i => ({
    label: i.study_name,
    value: i.study_id
  }))

  const mrOptions = getMrData && getMrData?.map(i => ({
    label: i.study_name,
    value: i.study_id
  }))
  const msOptions = msdropdowns && msdropdowns?.map(i => ({
    label: i.study_name,
    value: i.study_id
  }))
  const mhOptions = mhMainStudies && mhMainStudies?.map(i => ({
    label: i.study_name,
    value: i.study_id
  }))

  const pmsoptions = getPmsStudyData1 && getPmsStudyData1?.map(i => ({
    label: i.study_name,
    value: i.study_id
  }))
  

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    validatePassword(password, e.target.value);
  };
  const validatePassword = (newPassword, confirmPassword) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/;
    if (newPassword !== confirmPassword) {
      setPasswordError('Passwords don’t match');
      setIsPasswordMatching(false);
    } else if (!regex.test(newPassword)) {
      setPasswordError(' Note: Password must be at least 8 characters long, contain uppercase and lowercase letters, and include special characters.');
      setIsPasswordMatching(false);
    } else {
      setIsPasswordMatching(true);
      setPasswordError('');
    }
  };
const handlereload =()=>{
  window.location.reload()
}

  
  const handleSubmit = async(e) => {
    e.preventDefault(); 
    if (!passwordError) {
     
    } else {
      console.error('Invalid password or passwords do not match');
    }
   

    try {
      const response = await axios.post(base_url + "password/update/initial/onborading", {
        "email":localStorage.getItem('email'),
        "password":password
      });

     if (response.data.message== "Successfully updated"){  
      handleCloseFirstModal();
     }
     else{
       
     }
    } catch (error) {
      console.error('API error:', error);
    }

  };
const [model,setModel]= useState("")
  const handleClosePfrofileModel=()=>{
      setModel("hide")
  }
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#9e9e9e",
      minHeight: "20px",
      height: "40px",
      lineHeight: "25px",
      width:"430px",
      boxShadow: state.isFocused ? null : null,
      '@media (max-width: 768px)': {
        width: "100%",
      },
      
    }),
    option: (provided) => ({
           ...provided,
         whiteSpace: "normal", // Allow text to wrap
         wordWrap: "break-word", // Allow text to wrap
         fontSize:"14px"
        
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0px 6px",

      
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px"
    }),
    indicatorSeparator: (state) => ({
      display: "none"
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      
    }),
      menu: (provided) => ({
        ...provided,
           width: "430px !important", // Limit the maximum width of the dropdown menu
          }),          
  };
  // Add a click event listener to the button to stop event propagation
  const handleButtonClick = (event) => {
    event.stopPropagation();
  };

  
  const handleModalHide = () => {
    // You can add additional logic here if needed
    // For example, clearing the form fields
    setPassword('');
    setConfirmPassword('');
  };
  const customNoOptionsMessage = () => {
    return 'No studies available';
  };

  return (
 <> <div className="navTop" style={{ backgroundColor: getBackgroundColor() }}>
 <img src="./images/BBIL_logo.svg" alt="" className=" brand_logo brandlogombl ps-2" />


 <div className='db_title_main'>
   {currentPath === '/pmsadmindashboard' && <p className='wishtitle'><b className='pe-2'>Welcome</b>  {userName && userName}</p>}
   {currentPath === '/pidashboard' && <p className='wishtitle'><b className='pe-2'>Welcome</b>  {userName && userName}</p>}
   {currentPath === '/qrdashboard' && <p className='wishtitle'><b className='pe-2'>Welcome</b>  {userName && userName}</p>}
   {currentPath === '/mhdashboard' && <p className='wishtitle'><b className='pe-2'>Welcome</b>  {userName && userName}</p>}
   {currentPath === '/mrdashboard' && <p className='wishtitle'><b className='pe-2'>Welcome</b>  {userName && userName}</p>}
   {currentPath === '/marketingstaffdashboard' && <p className='wishtitle'><b className='pe-2'>Welcome</b>  {userName && userName}</p>}


   <h3 className='title'>
     {title}
   </h3>
 </div>
 <div>

 </div>

 {<div className='nav_right_icons'>
            {rolecode == PMS_ADMIN && !studyDropdwn ? <div >

          <Select
        value={pmsoptions?.find((option) => option.value === localStorage.study_id)} // Set the value based on localStorage
        onChange={handlePmsChange}
       
        placeholder={localStorage?.study_name}
        options={pmsoptions || []}
        noOptionsMessage={customNoOptionsMessage}
        styles={customStyles}
      />

          </div> : ''}
   {rolecode == PRINCIPAL_INVESTIGATOR && !studyDropdwn && !btnDisable? 
   
   <div className='pe-0 pe-md-4 pe-lg-4 pe-xxl-4'>
     <div className='custom_dropdown_nav'>
          <Select
        value={options?.find((option) => option.value === localStorage.study_id)} // Set the value based on localStorage
        onChange={handleChange}
        // isDisabled={btnDisable}
        placeholder={localStorage?.study_name}
        options={options || []}
        noOptionsMessage={customNoOptionsMessage}
        styles={customStyles}
      />
    </div> 

   </div> : ''}


   {rolecode == QUALITY_REVIEWER && !studyDropdwn ? <div className='pe-4'>
     <div className='custom_dropdown_nav'>
          <Select
        value={qrOptions?.find((option) => option.value === localStorage.study_id)} // Set the value based on localStorage
        onChange={handleQrChange}
       
        placeholder={localStorage?.study_name}
        options={qrOptions || []}
        noOptionsMessage={customNoOptionsMessage}
        styles={customStyles}
      />

          </div> 

   </div> : ''}
   {rolecode == MEDICAL_REVIEWER && !studyDropdwn ? <div className='pe-4'>
    
     <div className='custom_dropdown_nav'>
          <Select
        value={mrOptions?.find((option) => option.value === localStorage.study_id)} // Set the value based on localStorage
        onChange={handleMrChange}
       
        placeholder={localStorage?.study_name}
        noOptionsMessage={customNoOptionsMessage}
        options={mrOptions || []}
        styles={customStyles}
      />

          </div> 

   </div> : ''}
      
   {rolecode == MARKETING_STAFF && !studyDropdwn ? <div className='pe-0 pe-md-4 pe-lg-4 pe-xxl-4'>
   <div className='custom_dropdown_nav'>
          <Select
        value={msOptions?.find((option) => option.value === localStorage.studyID)} // Set the value based on localStorage
        onChange={handleMSChange}
       
        placeholder={localStorage?.study_name}
        noOptionsMessage={customNoOptionsMessage}
        options={msOptions || []}
        styles={customStyles}
      />

          </div> 

   </div> : ''}

   {rolecode == MARKETING_HEAD && !studyDropdwn ? <div className='pe-0 pe-md-4 pe-lg-4 pe-xxl-4'>
     <div className='custom_dropdown_nav'>
          <Select
        value={mhOptions?.find((option) => option.value === localStorage.study_id)} // Set the value based on localStorage
        onChange={handleMHChange}
       
        placeholder={localStorage?.study_name}
        noOptionsMessage={customNoOptionsMessage}
        options={mhOptions || []}
        styles={customStyles}
      />

          </div> 

   </div> : ''}

   <div ref={notificationBarRef} className="notification-bar">
   {/* <img className='Cpointer' src="./images/icons/search.svg" alt="" /> */}
          <img src="./images/icons/bell.svg" alt=""
          className={`opacity-100 bell-icon`}
          onClick={toggleNotifications}
          //  onClick={handleButtonClick}
          //  title='Notifications' 
          data-tooltip-id={'Notifications'}
          data-tooltip-content={'Notifications'}
          />
          {pmsNotifications?.length > 0 && (
            <div className="notification-count">{pmsNotifications.length}</div>
          )}
   </div>
   
   
    {/* <SingleNotification /> */}
    {/* {notifications?.map((notification, index) => (
        <SingleNotification closelive={closeLiveNotification} key={index} message={JSON.stringify(notification)} />
      ))} */}
  {/* {showNotifications && <NotificationComponent notifications={pmsNotifications} closeNotification={toggleNotifications}/>} */}
  {showNotifications && (
  <div className="notification-dropdown " ref={notificationComponentRef}>
    <NotificationComponent notifications={pmsNotifications} closeNotification={toggleNotifications} />
  </div>
)}
   <div className="dropdown" style={{zIndex:1000}}>

     <div className="d-flex bell align-items-center gap-3">
       <div>
         <span className='user_letter'>{localStorage.getItem("login_user_name")?.charAt(0)}</span>
       </div>
     </div>
     
    
     <div className="dropdown-content " style={{width:"22rem"}}>

        <div className="card  " >
       <div className="card-header  d-flex justify-content-between">
       
        <span className='font-weight-bold text-black'> My profile</span>
       
      </div>
      <div className="card-body text-center">
       <div className='d-flex justify-content-center'>
         <span className='user_letter'>{localStorage.getItem("login_user_name")?.charAt(0)}</span>
       </div>
       <p className='d-flex justify-content-center' style={{ margin: 0, padding: 0, color:"black" }}>{localStorage.getItem("login_user_name")}</p>
      
        {localStorage.getItem("contact_number") !== null && (
            <p className='d-flex justify-content-center' style={{ margin: 0, padding: 0 }}>
              {localStorage.getItem("contact_number")}
            </p>
          )}
         
        <p className='d-flex justify-content-center text-lowercase text-wrap ow-break-word' style={{ margin: 0, padding: 0 }}>{localStorage.getItem("email")}</p>

        <p className='d-flex justify-content-center mt-2 text_dec' data-bs-toggle="modal" data-bs-target="#upadtemodel" style={{color:"#109E62"}}>Update Your Password</p>

 
      <button  type="button" className="btn btn-light rounded border" data-bs-toggle="modal" data-bs-target="#exampleModal" style={{width:"120px"}}>
              Log Out
      </button>
  
      <div className='mt-2'>(Version: {packageJson.version}) </div>
       
      </div>
       </div>
     </div>

    </div>
 </div>}

</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content logoutpop">
      <div className="modal-body mt-3">
        Are you sure you want to logout ?
      </div>
      <div className="modal-footer d-flex justify-content-between w-100">
        <button type="button" className="gray_btn col py-1 justify-content-center" data-bs-dismiss="modal">No</button>
        <button type="button" className="orange_btn col py-1 justify-content-center"  onClick={logOut}>Yes</button>
      </div>

    </div>
  </div>
</div>

<div className={`modal fade ${model}`} id="upadtemodel" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content logoutpop">
    {/* {showCard && ( */}
    <div className="card" style={{width: "25rem"}}>
    <div className="card-header  d-flex justify-content-between ">
       
  
       <h6 className="modal-title" id="exampleModalLabel">Update Your Password</h6>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleModalHide}></button>
     </div>
     <div className="card-body">
      <form onSubmit={handleSubmit}>
        <div className="input-with-icon mt-3">
          <label htmlFor="password " className='font-weight-bold text-black'>Enter new password</label>
          <input
            id="password"
            type="password"
            className="input_data"
            placeholder="Enter Password"
            value={password}
            onChange={handlePasswordChange}
          />
        </div>
        <div className="fields mt-3">
          <label htmlFor="confirmPassword" className='font-weight-bold text-black'>Confirm password</label>
          <div className="input-with-icon">
            <input
              id="confirmPassword"
              type={showPassword ? "text" : "password"}
              className="input_data"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
            />
            <span className="password-toggle" onClick={togglePasswordVisibility}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>
        {passwordError && <p className="text-danger mt-2 fs-200">{passwordError}</p>}
        <div className='text-center'>
          <button type="submit"  className={`btn  mt-3 ${isPasswordMatching ? 'btn-custom-color' : 'btn-light'}`} disabled={passwordError || password !== confirmPassword || !isPasswordMatching} style={{width:"120px"}} >Update</button>
        </div>
      </form>
    </div>
   </div>

    {/* )} */}
    </div>
  </div>
</div>
 
{showModal && (
<div className="modal fade show" style={{ display: 'block' }}>
   <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content logoutpop">
      <div className="modal-footer d-flex justify-content-between w-100 card">
        <p className='mb-3'> Your password has been updated successfully</p>
      <button type="button" className="gray_btn col py-2 justify-content-center" data-bs-dismiss="modal" style={{width:"120px"}} onClick={() => handlereload()}>Close</button>

      </div>

    </div>
  </div>

</div>
      )}
</>  

  );
};




export default NavigationBar;
